//Filter Reducer

import  filtersReducerDefaultState from '../Components/FiltersDefaultState';

export default (state = filtersReducerDefaultState, action) => {
    switch(action.type) {
        case 'SET_SEASON_FILTER':
            return {
                ...state,
                testSubmissionCycleYear : action.testSubmissionCycleYear
            };
        case 'SET_TEST_REQUEST_ID_FILTER':
            return {
                ...state,
                testRequestIdentifier : action.testRequestIdentifier
            };
        case 'SET_SUPPLIED_MATERIAL_ID_FILTER':
            return {
                ...state,
                suppliedMaterialIdentifier : action.suppliedMaterialIdentifier

            };
        case 'SET_NIKE_PPS_ITEM_NUMBER_FILTER':
            return {
                ...state,
                nikePPSItemNumber : action.nikePPSItemNumber

            };
        case 'SET_TEST_TYPE_FILTER':
            return {
                ...state,
                testSubmissionType : action.testSubmissionType

            };
        case 'SET_END_USE_FILTER':
            return {
                ...state,
                nikeMsEndUse : action.nikeMsEndUse

            };
        case 'SET_MATERIAL_TYPE_FILTER':
            return {
                ...state,
                materialType : action.materialType

            };
        case 'SET_SUPPLIER_LOCATION_FILTER':
            return {
                ...state,
                supplierLocation : action.supplierLocation

            };
        case 'SET_LAB_FILTER':
            return {
                ...state,
                testLabIdentifier : action.testLabIdentifier

            };
        case 'SET_LAB_TEST_STATE_FILTER':
            return {
                ...state,
                labTestState : action.labTestState

            };
        case 'SET_LAB_TEST_STATUS_FILTER' :
            return {
                ...state,
                testSubmissionStatusIndicator : action.testSubmissionStatusIndicator
            };
        case 'SET_FILTERS':
            return {
                ...state,
                ...action.payload
            };
        case 'CLEAR_FILTER_SELECTION' :
            return {
                ...state,
                ...filtersReducerDefaultState
            };
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/Reducers/filters.js